import EuroPriceViewer from './components/EuroPriceViewer';
import './App.css';

function App() {
  return (
    <div
      className="App"
      style={{
        width: '100vw',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: '#f5f5f5',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ maxWidth: '1400px', width: '100%', padding: '20px', paddingTop: '20px' }}>
        <EuroPriceViewer />
      </div>

      <footer
        style={{
          marginTop: 'auto',
          padding: '40px 20px',
          textAlign: 'center',
        }}
      >
        <a
          href="https://americanterawatt.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            fontSize: '14px',
            color: '#999',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => {
            const companyName = e.currentTarget.querySelector('.company-name') as HTMLElement;
            if (companyName) {
              companyName.style.textDecoration = 'underline';
            }
            e.currentTarget.style.color = '#666';
          }}
          onMouseLeave={(e) => {
            const companyName = e.currentTarget.querySelector('.company-name') as HTMLElement;
            if (companyName) {
              companyName.style.textDecoration = 'none';
            }
            e.currentTarget.style.color = '#999';
          }}
        >
          <span>Presented by</span>
          <img
            src="/logo.png"
            alt="American Terawatt"
            style={{
              height: '24px',
              objectFit: 'contain',
              verticalAlign: 'middle',
            }}
          />
          <span className="company-name">American Terawatt</span>
        </a>
      </footer>
    </div>
  );
}

export default App;